export interface IValidation {
    firstName: boolean,
    middleInitial: boolean,
    lastName: boolean,
    email: boolean,
    mobile: boolean,
    birthdate: boolean,
    watrEmailDuplicate: boolean,
    watrMobileDuplicate: boolean,
    invalidDonationDate: boolean,
    addressLine1: boolean,
    addressLine2: boolean,
    city: boolean,
    state: boolean,
    postalCode: boolean,
    country: boolean,
    countryOfCitizenship: boolean
}